import { SortOrder } from '@models/table.model.ts';
import { ReactNode } from 'react';

export interface MediaLibraryComponentProps {
  trigger?: ReactNode;
  title?: string;
  mediaKey: string;
  allowedTypes?: (
    | FileTypeEnum.All
    | FileTypeEnum.Image
    | FileTypeEnum.Audio
    | FileTypeEnum.Video
  )[];
  onSelect?: (media: MediaModel | null) => void;
  path?: string;
  width?: number | string;
  height?: number | string;
  icon?: ReactNode;
  disableDelete?: boolean;
}

export interface FolderModel {
  id: string;
  parentId: string | null;
  createdAt: string;
  updatedAt: string;
  orgId: number;
  title: string;
  folderCount: number;
  assetsCount: number;
}

export interface MediaModel {
  _id: string;
  name: string;
  folder: any;
  isPrivate: boolean;
  size: number;
  path: string;
  mimetype: string;
  type: string;
  organizationId: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface MoveTreeModel {
  name: string;
  id: string;
  children: Children[];
}

export interface Children {
  id: string;
  name: string;
  path: string;
  mediaCount: number;
  createdAt: string;
  updatedAt: string;
  children: Children2[];
}

export interface Children2 {
  id: string;
  name: string;
  path: string;
  mediaCount: number;
  createdAt: string;
  updatedAt: string;
  children: Children3[];
}

export interface Children3 {
  id: string;
  name: string;
  path: string;
  mediaCount: number;
  createdAt: string;
  updatedAt: string;
  children: any[];
}

export interface FolderItemProps {
  data: any;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
  onFolderClick: (data: any) => void;
  onEditClick: (data: any) => void;
}

export interface MediaItemProps {
  data: any;
  checked: boolean;
  disabled?: boolean;
  isSelected?: boolean;
  onSelect?: (media: MediaModel | null) => void;
  onCheckedChange: (checked: boolean) => void;
  onEditClick: (data: any) => void;
  onDeleteClick: (data: any) => void;
  onPreviewClick?: (data: MediaModel) => void;
  onDownloadClick?: (data: MediaModel) => void;
}

export enum FileTypeEnum {
  All = 'all',
  Image = 'image',
  Audio = 'audio',
  Video = 'video',
  Document = 'document'
}

export const filterOptions = [
  { title: 'All', column: 'type', value: 'all' },
  { title: 'Image', column: 'type', value: 'image' },
  { title: 'Video', column: 'type', value: 'video' },
  { title: 'Audio', column: 'type', value: 'audio' },
  { title: 'Document', column: 'type', value: 'document' }
];

export const sortOptions = [
  {
    title: 'Most recent uploads',
    column: 'createdAt',
    value: SortOrder.Descending
  },
  { title: 'Oldest Uploads', column: 'createdAt', value: SortOrder.Ascending },
  { title: 'File Name (A–Z)', column: 'name', value: SortOrder.Ascending },
  { title: 'File Name (Z–A)', column: 'name', value: SortOrder.Descending },
  {
    title: 'File Size (Smallest First)',
    column: 'size',
    value: SortOrder.Ascending
  },
  {
    title: 'File Size (Largest First)',
    column: 'size',
    value: SortOrder.Descending
  },
  { title: 'Last Modified', column: 'updatedAt', value: SortOrder.Descending }
];
